import { render } from "./SVGGrainTest.vue?vue&type=template&id=6224de08&scoped=true"
import script from "./SVGGrainTest.vue?vue&type=script&lang=js"
export * from "./SVGGrainTest.vue?vue&type=script&lang=js"

import "./SVGGrainTest.vue?vue&type=style&index=0&id=6224de08&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6224de08"

export default script